"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEST_MERCHANT_MID = exports.TEST_AUTH_TOKEN = exports.DASHBOARD_PREFERENCE = exports.PRODUCT = exports.MERCHANT_MID = exports.AUTH_TOKEN = exports.MERCHANT_SESSION = exports.ENV = void 0;
var ENV = {
  DEV: "DEV",
  STAGING: "STAGING",
  UAT: "UAT",
  PROD: "PROD"
};
exports.ENV = ENV;
var MERCHANT_SESSION = {
  LIVE: 'live',
  TEST: 'test'
};
exports.MERCHANT_SESSION = MERCHANT_SESSION;
var AUTH_TOKEN = 'merchantAccessToken',
    MERCHANT_MID = 'mid',
    PRODUCT = 'product',
    DASHBOARD_PREFERENCE = 'dashboardPreference',
    TEST_AUTH_TOKEN = 'testAccessToken',
    TEST_MERCHANT_MID = 'test_mid';
exports.TEST_MERCHANT_MID = TEST_MERCHANT_MID;
exports.TEST_AUTH_TOKEN = TEST_AUTH_TOKEN;
exports.DASHBOARD_PREFERENCE = DASHBOARD_PREFERENCE;
exports.PRODUCT = PRODUCT;
exports.MERCHANT_MID = MERCHANT_MID;
exports.AUTH_TOKEN = AUTH_TOKEN;